import {Component, Input} from '@angular/core';
import {CategoryService} from '../../../services/category-service';
import { CommonService } from '../../../services/common.service';

@Component({
    selector: 'category-menu',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class CategoryMenuComponent {
  @Input() openCatMenu: boolean;
  @Input() isLoggedIn: boolean;
  @Input() gazetteUrl: string;
  public categories;

  constructor(
    public categoryService: CategoryService,
    public commonService: CommonService
  ) {
    this.categoryService.load().then(data => (this.categories = data));
  }
  public navigate(path) {
    this.commonService.navigate(path);
  }
}